import { render, staticRenderFns } from "./CGasRefinery.vue?vue&type=template&id=4339fe41"
import script from "./CGasRefinery.vue?vue&type=script&lang=js"
export * from "./CGasRefinery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports